(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("openseadragon"));
	else if(typeof define === 'function' && define.amd)
		define(["openseadragon"], factory);
	else if(typeof exports === 'object')
		exports["OpenSeadragon"] = factory(require("openseadragon"));
	else
		root["OpenSeadragon"] = root["OpenSeadragon"] || {}, root["OpenSeadragon"]["Annotorious"] = factory(root["OpenSeadragon"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__8202__) => {
return 